module.exports = __webpack_public_path__ + "static-m/img/z3.a8aa42a3.jpg";